module.exports = new __parcel__URL__("cartIMG.15673894.png").toString();